window.Frame = window.Frame || {};
window.Frame.Redirects = window.Frame.Redirects || {};
window.Frame.Redirects.Stores = [
  {
    "store_code": "gb",
    "store_label": "United Kingdom",
    "url": window.location.origin.includes('testing') ? "https://source-bmx-testing.myshopify.com" : "https://www.sourcebmx.com",
    "default_currency": "GBP"
  },
  {
    "store_code": "us",
    "store_label": "United States",
    "url": "https://us.sourcebmx.com",
    "default_currency": "USD"
  },
  {
    "store_code": "am",
    "store_label": "Americas",
    "url": "https://am.sourcebmx.com",
    "default_currency": "USD"
  },
  {
    "store_code": "eu",
    "store_label": "EU",
    "url": "https://eu.sourcebmx.com",
    "default_currency": "EUR"
  },
  {
    "store_code": "row",
    "store_label": "Rest of the World",
    "url": "https://row.sourcebmx.com",
    "default_currency": "GBP"
  }
]